<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Editar pagamento</h5>
        <div role="button" class="btn-close" @click="close"></div>
      </div>

      <div class="modal-body">
        <error-component :errors="errors" v-if="showError" />

        <form>
          <row-component>
            <col-component
              class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
              :class="{ formError: errors.payment_id }"
            >
              <label>Forma de pagamento:</label>
              <MultiSelect v-model="formData.payment_id" :options="selectPaymentMethod" />
            </col-component>

            <col-component
              class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
              :class="{ formError: errors.price }"
            >
              <label>Preço:</label>
              <input-component v-model="formData.price" v-money="MONEY" @input="handleCalc" />
            </col-component>

            <col-component
              class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
              :class="{ formError: errors.amount }"
            >
              <label>Quantidade:</label>
              <input-component v-model="formData.amount" type="number" @input="handleCalc" />
            </col-component>

            <col-component
              class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
              :class="{ formError: errors.price_total }"
            >
              <label>Preço total:</label>
              <input-component v-model="formData.price_total" v-money="MONEY" />
            </col-component>

            <col-component
              class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
              :class="{ formError: errors.cash_flow_generate }"
            >
              <label>Gerar fluxo de caixa:</label>
              <MultiSelect v-model="formData.cash_flow_generate" :options="selectYesOrNo" />
            </col-component>
          </row-component>

          <div v-if="Number(formData.cash_flow_generate) === 2">
            <hr />
            <row-component>
              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.bank_accounts_id }"
              >
                <label>Conta bancária:</label>
                <MultiSelect label="name" v-model="formData.bank_accounts_id" :options="selectAccountBankList" />
              </col-component>

              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.type_preview }"
              >
                <label>Fluxo caixa:</label>
                <MultiSelect v-model="formData.type_preview" :options="selectEffective" />
              </col-component>

              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.due_date }"
              >
                <label>Data de vencimento:</label>
                <input-component v-model="formData.due_date" v-mask="'##/##/####'" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.frequency }"
              >
                <label>Periodicidade:</label>
                <MultiSelect v-model="formData.frequency" :options="selectFrequencyList" />
              </col-component>
            </row-component>
          </div>

          <div class="text-end mt-3">
            <button-submit :disabled="sendForm" icon="save" name="Salvar" @click="submit" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import RowComponent from '@/components/row/RowComponent.vue';
import ColComponent from '@/components/row/ColComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import MultiSelect from '@/components/form/MultiSelect.vue';
import ButtonSubmit from '@/components/buttons/ButtonSubmit.vue';
import ErrorComponent from '@/components/alerts/ErrorComponent.vue';
import { VMoney } from 'v-money';
import { mask } from 'vue-the-mask';
import { MONEY } from '@/configs/constants';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  name: 'OrderPartEditPayment',

  components: {
    RowComponent,
    ColComponent,
    InputComponent,
    MultiSelect,
    ButtonSubmit,
    ErrorComponent
  },

  directives: {
    money: VMoney,
    mask
  },

  props: {
    orderPartId: {
      required: true
    },
    itemData: {
      type: Object,
      required: true
    }
  },

  created() {
    this.$store.dispatch('loadAccountBankMultiSelect');
    this.formData = {
      id: this.itemData.id,
      payment_id: this.itemData.payment_id ? Number(this.itemData.payment_id) : '',
      amount: this.itemData.amount,
      price: this.itemData.price,
      price_total: this.itemData.price_total,
      cash_flow_generate: Number(this.itemData.cash_flow_generate) || 2,
      bank_accounts_id: this.itemData.bank_accounts_id ? Number(this.itemData.bank_accounts_id) : '',
      type_preview: Number(this.itemData.type_preview) || 1,
      due_date: this.itemData.due_date,
      frequency: Number(this.itemData.frequency) || 3
    };
  },

  data() {
    return {
      MONEY,
      formData: {
        id: '',
        payment_id: '',
        amount: 1,
        price: '0,00',
        price_total: '0,00',
        cash_flow_generate: 2,
        bank_accounts_id: '',
        type_preview: 1,
        due_date: '',
        frequency: 3
      },
      errors: [],
      showError: false,
      sendForm: false
    };
  },

  computed: {
    selectPaymentMethod() {
      return this.$store.state.var.selectPaymentMethod;
    },
    selectYesOrNo() {
      return this.$store.state.var.selectYesOrNo;
    },
    selectEffective() {
      return this.$store.state.var.selectEffective;
    },
    selectFrequencyList() {
      return this.$store.state.var.selectFrequencyList.map(item => ({
        value: Number(item.value),
        label: item.label
      }));
    },
    selectAccountBankList() {
      return this.$store.state.var.selectAccountBankList;
    }
  },

  methods: {
    close() {
      this.$emit('close');
    },

    parseMoney(value) {
      if (!value) return 0;
      return Number(String(value).replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '')) || 0;
    },

    formatMoney(value) {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0);
    },

    handleCalc() {
      const amount = Number(this.formData.amount) || 1;
      const price = this.parseMoney(this.formData.price);
      this.formData.price_total = this.formatMoney(price * amount);
    },

    submit() {
      if (this.sendForm) return;
      this.sendForm = true;

      this.$store
        .dispatch('updateOrderPartPayment', {
          ...this.formData,
          amount: Number(this.formData.amount),
          order_part_id: this.orderPartId
        })
        .then(() => {
          this.sendForm = false;
          toast.success('Forma de pagamento atualizada com sucesso', { timeout: 1500 });
          this.$emit('saved');
          this.close();
        })
        .catch(e => {
          this.sendForm = false;
          this.showError = true;
          this.errors = e.response?.data?.errors || [];
          toast.error('Erro ao atualizar pagamento', { timeout: 1500 });
        });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 1100px;
  max-width: 90%;
  position: relative;
  max-height: 80%;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
</style>
